import type { FaireProductEntity } from "../../entity_types/product";

export const p_sqdhcfccfs: FaireProductEntity = {
  token: "p_sqdhcfccfs",
  type: "product",
  name: "Oy Fucking Vey Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/2296fb27e327ce8bc8b6477cdeea5d20c90d8dd81ecd20f4041f4c9948bb6b66.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6989c8e9e110b27a133249ac59e8666d0f3d4d24ec051653eb6a1939ec18ab6.jpeg",
    "https://cdn.faire.com/fastly/03468e4a676125d87d69a8767ef3850d75c19798a76d6e84f4d5a19013265c48.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/0aa6e0cdaccd853c930824c9121360bea815f7e42ee6075dc44b71298ef6ed37.jpeg",
    "https://cdn.faire.com/fastly/a8b37daf2f9e67e4c32628a102f7db821ab137a0ea84c9f27dd3e2806333db1a.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nThis is about the most satisfying interjection you could possibly let out. Go on, try it right now. Doesn't that feel good? Probably almost as good as these socks feel. 😜\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order. ",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:57.803Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
